import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import React from "react";
import { toast } from "sonner";
import { SSOAuthLogin } from "../../api/_request";
import { useNavigate } from "react-router-dom";
import { setCookieOnClientSide } from "../../lib/utils";

function GoogleLoginButton({ setIsLoginServiceCalled }: any) {
  const navigate = useNavigate();
  const searchBarParams = new URLSearchParams(window.location.search);
  const redirectURL = searchBarParams.get("redirect");
  const utmSource = searchBarParams.get("utm_source");
  const utmMedium = searchBarParams.get("utm_medium");
  const utmCampaign = searchBarParams.get("utm_campaign");
  const utmID = searchBarParams.get("utm_id");

  const onGoogleLoginSuccess = async (credentialResponse: any) => {
    try {
      // Ensure jwtDecode is called safely
      setIsLoginServiceCalled(true);
      // console.log("Google credentialResponse", jwtDecode(credentialResponse?.credential));
      const { credential, clientId, select_by } = credentialResponse;
      const { email, name } = jwtDecode<DecodedToken>(
        credentialResponse?.credential
      );

      if (!credential) {
        //throw new Error("Token decoding failed");
        toast.error("Oops!! Please try again.");
        setIsLoginServiceCalled(false);
      }

      // console.log("userExists", userExists);

      const googleLoginReqBody = {
        credential,
        clientId,
        select_by,
        //id_token: credential,
      };
      const googleLoginResponse = await SSOAuthLogin(
        googleLoginReqBody,
        "user",
        "google"
      );
      const {
        code,
        data: { jwt, role, session_token },
      } = googleLoginResponse;
      const { user_id } = jwtDecode<any>(jwt);

      if (+code === 200) {
        const setCookieBody: SetCookieInterface = {
          token: session_token,
          userID: user_id,
          userDataJwt: jwt,
          utmCampaign,
          utmMedium,
          redirectURL,
          type: "USER",
          regRef: "uwc_user_login",
          method: "google",
          event: "uwc_login",
          authUserRole: role,
          provider: email?.split("@")[1],
          displayName: name?.split(" ")[0],
        };

        setCookieOnClientSide(setCookieBody);
      }
    } catch (error) {
      console.error("Error in Google login process:", error);
      toast.error("Oops!! Please try again.");
      setIsLoginServiceCalled(false);
      // Handle any errors that occurred during the login process
    }
  };

  return (
    <div className="relative pl-2">
      <GoogleLogin
        onSuccess={onGoogleLoginSuccess}
        onError={() => {
          console.log("Login Failed");
        }}
        //type="icon"
        theme="outline"
        shape="rectangular"
        size="large"
        text="signin"
        width={"343"}
        ux_mode="popup"
        logo_alignment="center"
      />
    </div>
  );
}

export default GoogleLoginButton;
